<template>
  <div class="item-list">
    <div class="uk-card uk-card-hover uk-card-body">
      <div uk-grid>
        <div class="uk-width-auto">
          <img :src="item.imgUrl" alt="" style="max-width: 32px">
        </div>
        <div class="item-text uk-width-expand">
          <h5>{{ item.title }}</h5>
          <p>{{ item.text }}</p>
          <a class="item-link" target="_blank" :href="item.itemLink"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  .item-list
    .uk-card-body
      padding: 20px 20px 10px
      background-color: white
  .item-text
    h5
      margin-bottom: 12px
    p
      margin-top: 12px
      margin-bottom: 12px
      line-height: 1.4
      height: 36px
      overflow: hidden
      font-size: .8125em
      color: #3C464D
      text-overflow: ellipsis
  .item-link
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
</style>
